import { Icon } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';

const DescriptionHelpers = ({ className }: { className: string }) => {
  const { t } = useTranslation('app');
  return (
    <div
      className={`${className} w-full md:w-[266px] bg-orange_light_2 rounded-[12px] py-1.5x px-2x flex flex-col gap-1.5x`}
    >
      <div className="flex gap-x">
        <Icon name="lamb" size="24px" className="text-orange" />
        <p className="text-orange_dark_2 text-link">{t('tipsForListing')}</p>
      </div>
      <div className="flex flex-col gap-x">
        <p className="flex gap-x text-orange_dark_2">
          <span className="w-[24px] text-center">•</span>
          <span className="text-caption md:text-body_2 flex-1">
            {' '}
            {t('descriptionAlert1')}
          </span>
        </p>
        <p className="flex gap-x text-orange_dark_2">
          <span className="w-[24px] text-center">•</span>
          <span className="text-caption md:text-body_2 flex-1">
            {' '}
            {t('descriptionAlert2')}
          </span>
        </p>
      </div>
    </div>
  );
};

export default DescriptionHelpers;
